import {ListView, createInitialState} from "../ListView";
import {Form, FormListener} from "../../form/Form";
import * as React from "react";
import {User, ListUsersRequest, ItemPlayersRequest, ItemView} from "../../../../generated/protocol";
import {PagerModel} from "../../list/PagerModel";
import {EntityDataTable} from "../../list/EntityDataTable";
import {ListUtils} from "../../list/ListUtils";
import {RouterView, LoadingViewState} from "../RouterView";
import * as _ from "lodash";
import {kernel} from "../../../ioc/IOCHelper";
import {Validators} from "../../form/Validators";
import {ITEM_PLAYERS_SERVICE_NAME, ItemPlayersService} from "../../../service/admin/ItemPlayersService";
import {ITEM_SERVICE_NAME, ItemService} from "../../../service/admin/ItemService";


interface State extends LoadingViewState {
    listRequest?: ItemPlayersRequest;
    form?: ItemPlayersRequest;
    validationMap?: any,
    item?: ItemView
}

export class ItemPlayersListView extends ListView<State, ItemPlayersRequest> implements FormListener<ItemPlayersRequest> {
    onSubmit: () => (void | Promise<any>);

    columns = [
        {property: "userId", name: "ID", orderBy: "ID"},
        {property: "userName", name: "Username", orderBy: "userName"},
        {property: "externalUserId", name: "XID", orderBy: "externalUserId"}
    ];
    actions = [
        {id: "view", name: "View", className: "btn btn-primary", iconClassName: "fa fa-eye"}
    ];


    itemService: ItemService;
    itemPlayersService: ItemPlayersService;

    constructor(props) {
        super(props, "/item/" + props.params.id + "/players");
        this.state = createInitialState({itemId: props.params.id, limit: 50, orderBy: "player"}, this.state);
        this.itemPlayersService = kernel.get<ItemPlayersService>(ITEM_PLAYERS_SERVICE_NAME);
        this.itemService = kernel.get<ItemService>(ITEM_SERVICE_NAME);
        this.itemService.getEntity(props.params.id).then((item) => {
            this.setState({item: item});
        });
    }

    loadContent(): Promise<any> {
        return undefined;
    }

    formDidUpdate(formModel: ListUsersRequest, validationMap: any): void {
        this.setState({"form": formModel, validationMap: validationMap});
    }

    onSubmitError(): void {

    };

    pagerChanged(pager: PagerModel) {
        var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
        this.setState({listRequest: listRequest});
    }

    onAction(item: User, action: string) {
        if (action == "view") {
            this.navigate("/user/" + item.userId);
        }
    }

    getTitle() {
        return "Users with item : ";
    }

    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>{this.getTitle()}{this.state.item ? this.state.item.name + "(" + this.state.item.nameId + ")" : ""}</h1>
                    </div>
                </div>

                <div className="wrapper wrapper-content">
                    <EntityDataTable service={this.itemPlayersService} onPagerChange={this.pagerChanged.bind(this)}
                                     columns={this.columns}
                                     listRequest={this.state.listRequest} onAction={this.onAction.bind(this)}
                                     actions={this.actions}/>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/view/item/ItemPlayersListView.tsx